
import { useEffect } from 'react';

const AgendamentoPage = () => {
  useEffect(() => {
    // Initialize Calendly widget
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8' }}>
      {/* Header Section */}
      <div className="bg-white border-b" style={{ borderColor: '#C0C0C0' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center">
            <h1 
              className="text-4xl md:text-5xl font-bold mb-6"
              style={{ 
                fontFamily: 'Cinzel Decorative, serif',
                color: '#0B0B0B'
              }}
            >
              Agende sua Consulta
            </h1>
            <p 
              className="text-xl max-w-3xl mx-auto leading-relaxed"
              style={{ 
                color: '#C0C0C0',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Reserve um horário para uma consulta personalizada com nossos especialistas em alfaiataria. 
              Discutiremos suas necessidades, medidas e preferências para criar peças únicas sob medida.
            </p>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center">
            <div 
              className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#0F3F2F' }}
            >
              <i className="ri-user-line text-2xl text-white"></i>
            </div>
            <h3 
              className="text-xl font-bold mb-3"
              style={{ 
                fontFamily: 'Playfair Display, serif',
                color: '#0B0B0B'
              }}
            >
              Consulta Personalizada
            </h3>
            <p 
              className="text-base"
              style={{ 
                color: '#C0C0C0',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Atendimento individual para entender suas necessidades e estilo pessoal
            </p>
          </div>

          <div className="text-center">
            <div 
              className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#0F3F2F' }}
            >
              <i className="ri-ruler-line text-2xl text-white"></i>
            </div>
            <h3 
              className="text-xl font-bold mb-3"
              style={{ 
                fontFamily: 'Playfair Display, serif',
                color: '#0B0B0B'
              }}
            >
              Medidas Precisas
            </h3>
            <p 
              className="text-base"
              style={{ 
                color: '#C0C0C0',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Tomada de medidas profissional para garantir o caimento perfeito
            </p>
          </div>

          <div className="text-center">
            <div 
              className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#0F3F2F' }}
            >
              <i className="ri-palette-line text-2xl text-white"></i>
            </div>
            <h3 
              className="text-xl font-bold mb-3"
              style={{ 
                fontFamily: 'Playfair Display, serif',
                color: '#0B0B0B'
              }}
            >
              Seleção de Tecidos
            </h3>
            <p 
              className="text-base"
              style={{ 
                color: '#C0C0C0',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Escolha entre nossa seleção premium de tecidos importados
            </p>
          </div>
        </div>

        {/* Calendly Widget */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/contatoorenancavalcanti/30min"
            style={{ minWidth: '320px', height: '700px' }}
          ></div>
        </div>

        {/* Additional Information */}
        <div className="mt-16 bg-white rounded-lg p-8 shadow-lg">
          <h2 
            className="text-2xl font-bold mb-6 text-center"
            style={{ 
              fontFamily: 'Playfair Display, serif',
              color: '#0B0B0B'
            }}
          >
            O que esperar da sua consulta
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 
                className="text-lg font-bold mb-4"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#0F3F2F'
                }}
              >
                Durante a consulta:
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#0F3F2F' }}></i>
                  <span 
                    className="text-base"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Análise do seu estilo e necessidades
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#0F3F2F' }}></i>
                  <span 
                    className="text-base"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Tomada de medidas detalhada
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#0F3F2F' }}></i>
                  <span 
                    className="text-base"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Apresentação do catálogo de tecidos
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-lg mt-1" style={{ color: '#0F3F2F' }}></i>
                  <span 
                    className="text-base"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Definição de detalhes e acabamentos
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <h3 
                className="text-lg font-bold mb-4"
                style={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#0F3F2F'
                }}
              >
                Informações importantes:
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <i className="ri-time-line text-lg mt-1" style={{ color: '#0F3F2F' }}></i>
                  <span 
                    className="text-base"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Duração: 30-45 minutos
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-map-pin-line text-lg mt-1" style={{ color: '#0F3F2F' }}></i>
                  <span 
                    className="text-base"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Atendimento presencial ou virtual
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-money-dollar-circle-line text-lg mt-1" style={{ color: '#0F3F2F' }}></i>
                  <span 
                    className="text-base"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Consulta gratuita sem compromisso
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-calendar-line text-lg mt-1" style={{ color: '#0F3F2F' }}></i>
                  <span 
                    className="text-base"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Reagendamento até 24h antes
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgendamentoPage;
